<template>
    <section class="our-customers mt-10">
      <v-container
       :fluid="true"
      >
      <v-skeleton-loader
              class="mx-auto white"
              height="450"
              type="image,image,image"
              v-if="loading"
            ></v-skeleton-loader>
        <v-carousel
             :cycle="false"
             :show-arrows-on-hover="true"
             hide-delimiter-background
             height="450"
             v-show="!loading"
             >
                <v-carousel-item
                 v-for="(carousel, index) in carouselData" :key="index"
                 :src='require(`@/assets/our-customerse/background reserve now.jpg`)'
                 >
                    <v-sheet
                        color="rgb(0, 0, 0,.3)"
                        height="100%"
                        style=""
                        >
                        <v-row
                         justify="center"
                         align="center"
                         class="pl-16 pr-16"
                         style="height:100%"
                         >
                         <div class="text-center">
                           <img class="mb-2" style="max-height: 94px;max-width: 94px;"  :src="carousel.avatar"  alt="" srcset="">
                           <h3 class="mb-4" style="font-size:20pt" v-text="carousel[lang].name ? carousel[lang].name :carousel.name "></h3>
                           <div style="position:relative">
                           <p class="white--text pl-2 pt-3 pb-3 pr-2  text-center" style="font-size:13pt" v-text="carousel[lang].text">
                           </p>
                            <v-overlay opacity="0.5" :absolute='true' dark :value="true" z-index="-1"></v-overlay>
                           </div>
                        </div>
                        </v-row>
                        </v-sheet>
                </v-carousel-item>
            </v-carousel>
      </v-container>
    </section>
</template>

<script>
import firebase from '@/firebase/index';
import {lang} from '@/mixins/index'
export default {
    name:'our_customers',
    data() {
        return {
            loading:false,
            carouselData:[],
            carousels:[
                {
                    name:'walid oughris',
                    avatar:'man1.png',
                    says:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur quasi aperiam in quod cumque sit voluptate neque illo animi nesciunt qui fuga aliquam doloremque voluptatem, culpa possimus nisi consectetur necessitatibus! ',
                    backImg:'background reserve now.jpg'
                },
                {
                    name:'walid oughris',
                    avatar:'man2.png',
                    says:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur quasi aperiam in quod cumque sit voluptate neque illo animi nesciunt qui fuga aliquam doloremque voluptatem, culpa possimus nisi consectetur necessitatibus!',
                    backImg:'background reserve now.jpg'
                },
                {
                    name:'walid oughris',
                    avatar:'man3.png',
                    says:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur quasi aperiam in quod cumque sit voluptate neque illo animi nesciunt qui fuga aliquam doloremque voluptatem, culpa possimus nisi consectetur necessitatibus!',
                    backImg:'background reserve now.jpg'
                }
            ]
        }
    },
    mixins:[lang],
    beforeMount(){
        this.loading=true;
        const db =firebase.firestore();
        const storage = firebase.storage();
        db.collection('ourCustomers').get()
         .then(snpshat=>{
             snpshat.forEach(doc=>{
                storage.ref(doc.data().avatar).getDownloadURL()
                 .then(url=>{
                    this.carouselData.push({
                        name:doc.data().name,
                        avatar:url,
                        ar:{
                            name:doc.data().ar.name,
                            text:doc.data().ar.text
                        },
                        en:{
                           text:doc.data().en.text
                        },
                        fr:{
                           text:doc.data().fr.text
                        }
                    })
                    this.loading=false
                 })
             })
         })
    }
}
</script>